import React, { useMemo } from 'react'
import CustomSelect from '../../../../../ui-kit/Dropdown/TaskDropdown'
import HierarchicalSelect from '../../../../../ui-kit/Dropdown/HierarchicalDropdwon/HierarchicalDropdwon'
import HierarchicalDropdwonWithParentInfo from '../../../../../ui-kit/Dropdown/HierarchicalDropdwon/HierarchicalDropdwonWithParentInfo'
import { useGetAllDepartmentsQuery } from '../../../../../slices/departmentsApiSlice'
import { formatMessage } from '../../../../../locale'
import { useSelector } from 'react-redux'
import CheckBox from '../../../../TaskType/Components/checkbox/CheckBox'

const removeDuplicateIds = (tree: any[]) => {
  const seen = new Set<number>()

  const filterDuplicates = (nodes: any[]): any[] => {
    if (!nodes || !nodes.length) return []

    return nodes
      .filter((node) => {
        // If we've seen this ID before, filter it out
        if (seen.has(node.id)) return false

        // Otherwise, add it to our set of seen IDs
        seen.add(node.id)
        return true
      })
      .map((node) => ({
        ...node,
        // Recursively filter children
        children: filterDuplicates(node.children),
      }))
  }

  return filterDuplicates(tree)
}

function ModalContent({
  selectedType,
  setSelectedType,
  selectedDepartments,
  setSelectedDepartments,
  selectedLanguage,
  setSelectedLanguage,
  deparmentDropdownOpen,
  languageDropdownOpen,
  setDepartmentDropdownOpen,
  setLanguageDropdownOpen,
  departments_tree,
}: any) {
  const { canExportSurvey  } = useSelector((state: any) => state.auth)
  const { data: departments } = useGetAllDepartmentsQuery(
    {},
    { skip: !canExportSurvey  }
  )

  const cleanedDepartmentsTree = useMemo(() => {
    return removeDuplicateIds(departments_tree || [])
  }, [departments_tree])

  const exportOptions = [
    {
      value: 'excel',
      label: formatMessage({
        id: 'createEditSurvey.exportSurveyResults',
        defaultMessage: 'Export survey results to Excel',
      }),
    },
    {
      value: 'powerpoint',
      label: formatMessage({
        id: 'createEditSurvey.exportSurveyPowerpoint',
        defaultMessage: 'Export survey results to PowerPoint',
      }),
    },
  ]

  const languageOptions = [
    { value: 'sv', label: 'Sv' },
    { value: 'en', label: 'En' },
  ]

  return (
    <div
      style={{
        display: 'flex',
        textAlign: 'left',
        flexDirection: 'column',
        gap: '16px',
        maxWidth: '400px',
        minWidth: '300px',
      }}
    >
      <h3>
        {formatMessage({
          id: 'createEditSurvey.exportSurvey',
          defaultMessage: 'Export survey results to Excel',
        })}
      </h3>
      <CustomSelect
        label={formatMessage({
          id: 'createEditSurvey.exportType',
          defaultMessage: 'Export type',
        })}
        value={selectedType}
        options={exportOptions}
        placeholder={formatMessage({
          id: 'createEditSurvey.chooseExportType',
          defaultMessage: 'Export type',
        })}
        isRequired={true}
        onChange={(selectedOption: any) => setSelectedType(selectedOption)}
      />
      {selectedType?.value === 'powerpoint' && (
        <>
          {canExportSurvey ? (
            <>
              {!deparmentDropdownOpen && (
                <HierarchicalDropdwonWithParentInfo
                  label={formatMessage({
                    id: 'createEditSurvey.department',
                    defaultMessage: 'Department/Business Unit/Team',
                  })}
                  value={selectedDepartments}
                  treeData={departments?.data}
                  placeholder={formatMessage({
                    id: 'createEditSurvey.chooseDepartment',
                    defaultMessage: 'Choose Department/Business Unit/Team',
                  })}
                  isRequired={true}
                  onChange={(selectedOption: any) =>
                    setSelectedDepartments(selectedOption)
                  }
                />)}
               <CheckBox
                label={formatMessage({
                id: 'createEditSurvey.exportAllDepartments',
                defaultMessage: 'Exportera alla avdelningar',
              })}
                isChecked={deparmentDropdownOpen}
                onChange={() => {setDepartmentDropdownOpen(!deparmentDropdownOpen)}}
                style={0}
          />
          </>
          ) : (
            <HierarchicalSelect
              label={formatMessage({
                id: 'createEditSurvey.department',
                defaultMessage: 'Department/Business Unit/Team',
              })}
              value={selectedDepartments}
              treeData={cleanedDepartmentsTree}
              placeholder={formatMessage({
                id: 'createEditSurvey.chooseDepartment',
                defaultMessage: 'Choose Department/Business Unit/Team',
              })}
              isRequired={true}
              onChange={(selectedOption: any) =>
                setSelectedDepartments(selectedOption)
              }
            />
          )}
          {!languageDropdownOpen && (
            
            <CustomSelect
              label={formatMessage({
                id: 'createEditSurvey.language',
                defaultMessage: 'Language',
              })}
              value={selectedLanguage}
              options={languageOptions}
              placeholder={formatMessage({
                id: 'createEditSurvey.chooseLanguage',
                defaultMessage: 'Choose language',
              })}
              isRequired={true}
              onChange={(selectedOption: any) =>
                setSelectedLanguage(selectedOption)
              }
            />)}
{/* 
          <CheckBox
            label={formatMessage({
                id: 'createEditSurvey.exportAllLanguages',
                defaultMessage: 'Export all languages',
              })}
            isChecked={languageDropdownOpen}
            onChange={() => {setLanguageDropdownOpen(!languageDropdownOpen)}}
            style={0}
          /> */}
        </>
      )}
    </div>
  )
}

export default ModalContent
